module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', _vm._g({
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    class: _vm.buttonClass,
    attrs: {
      "type": "button"
    }
  }, _vm.$listeners), [_vm._t("default", function() {
    return [(_vm.icon) ? _c('span', {
      class: _vm.iconClass
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "p-button-label"
    }, [_vm._v(_vm._s(_vm.label || ' '))]), _vm._v(" "), (_vm.badge) ? _c('span', {
      staticClass: "p-badge",
      class: _vm.badgeStyleClass
    }, [_vm._v(_vm._s(_vm.badge))]) : _vm._e()]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3676ff4d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/primevue/button/Button.vue
// module id = 2145
// module chunks = 0